import useApi from "../../index";
import useTypes from "../../../strings/types";

const useRolesActions = () => {
  // Services
  const { useServices } = useApi();
  const { useRolesServices } = useServices();
  const { addRoleService, editRoleService, listRolesService, deleteRoleService, getRoleByIdService } =
    useRolesServices();

  // Strings
  const { useRolesTypes } = useTypes();
  const { ADD_ROLE, REMOVE_ROLE } = useRolesTypes();

  const actSelectRole =
    ({ role }) =>
    (dispatch) => {
      dispatch({
        type: ADD_ROLE,
        payload: role,
      });
    };

  const actRemoveRole = () => (dispatch) => {
    dispatch({
      type: REMOVE_ROLE,
    });
  };

  const actListRoles = async ({ page, search }, onSuccess, onError) => {
    try {
      const response = await listRolesService({ page, search });
      onSuccess && onSuccess(response.data);
    } catch (error) {
      onError && onError();
    }
  };

  const actAddRole = async (data, onSuccess, onError) => {
    try {
      const response = await addRoleService(data);
      onSuccess && onSuccess(response.data.data);
    } catch (error) {
      console.log(error);
      onError && onError();
    }
  };

  const actEditRole = async (id, data, onSuccess, onError) => {
    try {
      const response = await editRoleService(id, data);
      onSuccess && onSuccess(response.data.data);
    } catch (error) {
      onError && onError();
    }
  };

  const actDeleteRole = async (id, onSuccess, onError) => {
    try {
      const response = await deleteRoleService(id);
      onSuccess && onSuccess(response.data.data);
    } catch (error) {
      onError && onError();
    }
  };

  const actGetRoleById = async (id, onSuccess, onError) => {
    try {
      const response = await getRoleByIdService(id);
      onSuccess && onSuccess(response.data.data);
    } catch (error) {
      onError && onError();
    }
  };

  return {
    actSelectRole,
    actRemoveRole,
    actListRoles,
    actAddRole,
    actEditRole,
    actDeleteRole,
    actGetRoleById,
  };
};

export default useRolesActions;
